import styled from 'styled-components';
import * as style from '../Styled';

/**
 * Styled constants
 */
export const StyledWrapper = styled.div`
  ${ style.wrapper() }
`;

export const StyledForm = styled.div`
  ${ style.form() }
`;

export const StyledFormSubmission = styled.div`
  ${ style.formSubmission() }
`;

export const StyledH1 = styled.h1`
  ${ style.heading('H1') }
`;

export const StyledStandardText = styled.div`
  ${ style.standardText() }
`;

export const StyledLargeText = styled.div`
  ${ style.largeText() }
`;

export const StyledCounterText = styled.span`
  ${ style.counterText() }
`;

export const StyledFieldLabel = styled.label`
  ${ style.fieldLabel() }
`;

export const StyledFlexRow = styled.div`
  ${ style.flexRow() }
`;

export const StyledFlexColumn = styled.div`
  ${ style.flexColumn() }
`;

export const StyledFieldInput = styled.div`
  ${ style.fieldInput() }
`;

export const StyledInputMessage = styled.div`
  ${ style.inputMessage() }
`;

export const StyledLine = styled.hr`
  ${ style.horizontalLine() }
`;

export const StyledPrimaryCtaButton = styled.div`
  ${ style.primaryCtaButton() }
`;

export const StyledSecondaryCtaButton = styled.div`
  ${ style.secondaryCtaButton() }
`;

export const StyledPhoneInput = styled.div`
  ${ style.phoneInput() }
`;

export const StyledErrorMessage = styled.div`
  ${ style.errorMessage() }
`;

export const StyledErrorNotice = styled.div`
  ${ style.errorNotice() }
`;

export const StyledBoldText = styled.span`
  ${ style.boldText() }
`;

export const StyledSpinner = styled.div`
  ${ style.spinner() }
`;

